export const sensorType = {
  water_counter: "water_counter",
  groundwater_sensor: "groundwater_sensor",
  weather_station: "weather_station",
  water_flow: "water_flow",
  water_storage: "water_storage",
};
